var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config && Array.isArray(_vm.config.nodes))?_c('div',{staticClass:"plugin-wrap rec-items layout"},_vm._l((_vm.config.nodes),function(node,index){return _c('div',{key:index,staticClass:"rec-item__image-wrap"},[_c('Xink',{attrs:{"action":node.action}},[_c('img',{staticClass:"show-for-md",attrs:{"src":node.src.pc},on:{"load":function($event){return _vm.onImgLoaded({
        src: node.src.pc,
        type: 'image',
        platform: 'desktop'
      })}}}),_c('img',{staticClass:"hide-for-md",attrs:{"src":node.src.h5},on:{"load":function($event){return _vm.onImgLoaded({
        src: node.src.h5,
        type: 'image',
        platform: 'mobile'
      })}}})])],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }